import { Injectable, signal } from '@angular/core';

@Injectable()
export class WorkspaceStateService {
  
    title = signal<string>('');     // e.g., toolbar title
    subtitle = signal<string>('');     // e.g., toolbar subtitle
    // sidebarOpen = signal<boolean>(true);

    clean() {
        this.title = signal<string>('');
        this.subtitle = signal<string>('');
    }
}